import { render, staticRenderFns } from "./Signalwire.vue?vue&type=template&id=c150fe68&"
import script from "./Signalwire.vue?vue&type=script&lang=js&"
export * from "./Signalwire.vue?vue&type=script&lang=js&"
import style0 from "./Signalwire.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports